import { Depot, IssueReport } from '../../../api/types';
export interface ConstructedIssueReport extends IssueReport {
    depot: Depot | undefined;
}
export const constructIssueReports = (permittedDamageReports: IssueReport[], permittedDepots: Depot[]): ConstructedIssueReport[] => {
    return permittedDamageReports.map((damageReport) => {
        const depot = permittedDepots.find((depot) => depot.id === damageReport.depotId);
        return {
            ...damageReport,
            depot: depot,
        };
    });
};

const getNestedValue = (obj: any, path: string) => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};

export const generateSelectOptions = (data: any[], keys: string[]) => {
    if (!data || keys.length === 0) {
        return [];
    }

    return data.map((item) => ({
        value: getNestedValue(item, keys[0]),
        text: keys.length === 1 ? getNestedValue(item, keys[0]) : getNestedValue(item, keys[1]),
    }));
};

export type IssueReportStatus = 'open' | 'in progress' | 'on hold' | 'done';

export function getIssueTypeText(key: string, t: (key: string) => string) {
    return t(`issue_type.${key}`) || key;
}
